import { render, staticRenderFns } from "./addVirtualDictGroup.vue?vue&type=template&id=c844c374&scoped=true&"
import script from "./addVirtualDictGroup.vue?vue&type=script&lang=js&"
export * from "./addVirtualDictGroup.vue?vue&type=script&lang=js&"
import style0 from "./addVirtualDictGroup.vue?vue&type=style&index=0&id=c844c374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c844c374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c844c374')) {
      api.createRecord('c844c374', component.options)
    } else {
      api.reload('c844c374', component.options)
    }
    module.hot.accept("./addVirtualDictGroup.vue?vue&type=template&id=c844c374&scoped=true&", function () {
      api.rerender('c844c374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/dictionary/addVirtualDictGroup.vue"
export default component.exports